import React, { Component } from "react";
import _ from 'i18n';

export default class EventLineChartErrorHandler extends Component {

  handleButtonClick = () =>{
    const {type} = this.props;

    if (type === 'CA'){
      const {fetchRegistrantLineChartCAData} = this.props;
      fetchRegistrantLineChartCAData();
    } else {const {fetchRegistrantLineChartData} = this.props;
      fetchRegistrantLineChartData();
   }
  }


  render() {

    const {data, fetching} = this.props;

    return (
      <div className={'flex items-center flex-column justify-center retry-container'} style={{minHeight : '300px'}}>
        <div className={'retry-label mb-3'}>{_('ERROR_OCCURED')}</div>
        <button type={"button"} className={'retry-button'} onClick={this.handleButtonClick}>
          {_('RETRY')}
        </button>
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartErrorHandler.js